<template>
  <v-layout>
    <v-flex xs12 sm12>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar
              color="accent"
              size="48">
              <span class="white--text headline">{{_avatar}}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{_user.username}}</v-list-item-title>
              <v-list-item-subtitle>{{_user.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="accent" @click="logout">Выйти</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'user-menu',

  computed: {
    ...mapGetters('user', {
      _user: 'user',
      _avatar: 'avatar'
    })
  },

  methods: {
    logout () {
      this._logout()
      this.$router.push({ name: 'login' })
    },
    ...mapActions('auth', {
      _logout: 'logout'
    })
  }
}
</script>

<style scoped>

</style>
